import { MAX_DISCOUNT_RATIO } from "./validators";
import { CREDIT_FIELDS, CREDIT_LINE } from "./studioConstants";
import { familyLabel, findByKey, unitOf, catalogPriceOfKey } from "./checkoutCatalog";

export const buildLines = ({ form, sub, credits, creditFields, catalog }) => {
  const out = [];
  const orig = (id) => {
    const v = form.originals[id];
    return v === "" || v == null ? null : Number(v);
  };
  if (sub) {
    if (sub.planKey) {
      const meta = findByKey(catalog, sub.planKey);
      out.push({
        id: "plan", rowKey: "plan", origKey: "plan",
        title: meta ? `Plan — ${meta.label}` : sub.planKey,
        amount: Number(form.subAmounts.plan) || 0,
        // Computed from the catalog, not stored
        originalAmount: catalogPriceOfKey(catalog, sub.planKey, form.currency),
        origLocked: true,
        unitPrice: null, recurring: true, source: "sub", tag: "Plan",
      });
    }
    (sub.addOns || []).forEach((a) => {
      const id = a.key;
      const meta = findByKey(catalog, a.key);
      const unit = Number(form.subUnitPrices[id]) || 0;
      const qty = Number(a.quantity) || 0;
      out.push({
        id, rowKey: id, origKey: id,
        title: `${familyLabel(catalog, a.family)} — ${meta ? meta.label : a.key}`,
        amount: Math.round(unit * qty * 100) / 100,
        originalAmount: (() => {
          const listed = catalogPriceOfKey(catalog, a.key, form.currency);
          return listed == null ? null : Math.round(listed * qty * 100) / 100;
        })(),
        origLocked: true,
        unitPrice: unit, recurring: true,
        source: "unit", tag: familyLabel(catalog, a.family), unitKey: id, qty,
        unitName: a.family === "flow_addon" ? "pack" : (unitOf(catalog, a.family) || "unit"),
      });
    });
  }
  if (credits) {
    creditFields.forEach((c) => {
      const qty = Number(credits[c.k]) || 0;
      if (qty <= 0) return;
      const unit = Number(form.creditPrices[c.k]) || 0;
      const id = CREDIT_LINE[c.k];
      out.push({
        id, rowKey: id, origKey: id,
        title: `${qty.toLocaleString("en-IN")} ${c.name}`,
        amount: Math.round(unit * qty * 100) / 100,
        originalAmount: orig(id), unitPrice: unit, recurring: false, source: "credit", tag: "Credits",
        creditKey: c.k, qty,
      });
    });
  }
  return out;
};

// What gets POSTed. Drops the row-only bookkeeping fields.
export const toLineItems = (lines) =>
  lines.map(({ id, title, amount, originalAmount, unitPrice, recurring }) =>
    ({ id, title, amount: Number(amount), originalAmount, unitPrice, recurring }));

// Amount above the list price is a negative discount: the preview would strike
// through a price LOWER than the one being charged.
export const overOriginal = (l) =>
  l.originalAmount != null && Number(l.amount) > Number(l.originalAmount) + 0.005;

export const belowFloor = (l) =>
  l.originalAmount != null && Number(l.amount) < Number(l.originalAmount) * (1 - MAX_DISCOUNT_RATIO) - 0.005;

// ---- Billing-preview cell helpers----
export const pvQty = (l) => (l.qty != null ? Number(l.qty) : 1);
export const pvUnit = (l) => (l.unitPrice != null ? Number(l.unitPrice) : Number(l.amount) || 0);

export const pvTitle = (l) => {
  if (l.source === "credit") {
    const cf = CREDIT_FIELDS.find((c) => c.k === l.creditKey);
    if (cf) return cf.name;
  }
  return l.title || "Untitled line";
};
